/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
//Indice para todos los SAGAS
import {all, fork} from "redux-saga/effects";

import * as LegalDocumentsSaga from "./LegalDocumentsSaga";

export default function * rootSaga() {
    let allSagas = Object.assign( LegalDocumentsSaga );

    yield all( [...Object.values(allSagas)].map(fork) );
}